<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div class="sidebar-header">
    <a class="logo" [routerLink]="['/']">
      @if (showLogo()) {
      <img class="logo-image" [src]="logoUrl()" alt="logo" />
      }

      @if (brandName()) {
      <span class="app-name text-5xl font-semibold leading-normal ml-2">
        {{ brandName() }}
      </span>
      }
    </a>

    <button class="layout-sidebar-anchor z-2" type="button" (click)="anchor()"></button>
  </div>

  <div #menuContainer class="layout-menu-container">
    @if (showTenantMenu()) {
    <app-active-tenant-menu class="mb-5 menu-layer flex"></app-active-tenant-menu>
    }
    <div app-menu></div>
  </div>
  <div app-topbar *ngIf="isHorizontal() && !layoutService.isMobile()"></div>
</div>